import { useState } from "react";
import { useNavigate } from "react-router-dom";
import bg1 from "../../Assets/background/bg1.jpg"; // adjust path
import bg2 from "../../Assets/background/bg2.jpg"; // adjust path

export default function SelectBG() {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const handleNext = () => {
    if (selected) {
      navigate(`/capture/${selected}`);
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div
        style={{
          position: "absolute",
          top: "20px",
          color: "#fff",
          textAlign: "center",
          fontSize: "28px",
          width: "100%",
        }}
      >
        Select Background
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginBottom: "20px",
          height: "80dvh",
          alignItems: "center",
        }}
      >
        {/* BG 1 */}
        <div>
          <img
            src={bg1}
            alt="Background 1"
            width={"80%"}
            style={{ border: selected === "1" ? "2px solid blue" : "none" }}
          />
          <div>
            <input
              type="radio"
              name="bg"
              value="1"
              checked={selected === "1"}
              onChange={(e) => setSelected(e.target.value)}
              style={{
                transform: "scale(2)",
                margin: "10px",
              }}
            />
          </div>
        </div>

        {/* BG 2 */}
        <div>
          <img
            src={bg2}
            alt="Background 2"
            width={"80%"}
            style={{ border: selected === "2" ? "2px solid blue" : "none" }}
          />
          <div>
            <input
              type="radio"
              name="bg"
              value="2"
              checked={selected === "2"}
              onChange={(e) => setSelected(e.target.value)}
              style={{
                transform: "scale(2)",
                margin: "10px",
              }}
            />
          </div>
        </div>
      </div>

      {/* Next button appears only after selecting */}
      <button
        className="rippleBtn"
        disabled={!selected}
        onClick={handleNext}
        style={{
          padding: "10px 20px",
          fontSize: "16px",
          cursor: selected ? "pointer" : "not-allowed",
        }}
      >
        Next
      </button>
    </div>
  );
}
